const RETURN_TO_KEY = "provisioning-portal/return-to";

// After a deliberate "Log out" the next sign-in should land on the dashboard, not on the page
// the user happened to leave from. Cleared again on the next successful sign-in.
let manualLogout = false;

export function markManualLogout() {
  manualLogout = true;
  clearReturnTo();
}

export function markSignedIn() {
  manualLogout = false;
}

/** Remember the page to come back to after signing in (ignores the auth pages themselves). */
export function rememberReturnTo(path: string) {
  if (typeof window === "undefined" || manualLogout || !path.startsWith("/") || path.startsWith("/login")) {
    return;
  }
  try {
    window.sessionStorage.setItem(RETURN_TO_KEY, path);
  } catch {
    // Storage can be unavailable (private mode); falling back to the dashboard is fine.
  }
}

/** The remembered page, or null. Only same-site paths are returned. */
export function peekReturnTo(): string | null {
  if (typeof window === "undefined") {
    return null;
  }
  try {
    const path = window.sessionStorage.getItem(RETURN_TO_KEY);
    return path && path.startsWith("/") && !path.startsWith("//") ? path : null;
  } catch {
    return null;
  }
}

export function clearReturnTo() {
  if (typeof window === "undefined") {
    return;
  }
  try {
    window.sessionStorage.removeItem(RETURN_TO_KEY);
  } catch {
    // ignore
  }
}

export function currentPath() {
  return typeof window === "undefined" ? "/" : `${window.location.pathname}${window.location.search}`;
}
